import React, { memo } from 'react';
import { useAppSelector } from 'store';
import { SendSmsDialog } from './send-sms-dialog';

export const SendSms = memo(() => {
  const { sendSms } = useAppSelector((state) => state.TaskManager);
  return sendSms ? <SendSmsDialog /> : null;
});
